/**
 * Copyright © 2026 Adnuntius AS.
 */
export interface ReportOption {
  id: string;
  langs: string[];
}

export const REPORT_OPTIONS: ReportOption[] = [
  {
    id: 'network_1',
    langs: ['en', 'de']
  },
  {
    id: 'da_trippers',
    langs: ['en', 'de']
  },
  {
    id: 'russ',
    langs: ['en', 'de']
  },
  {
    id: '107727',
    langs: ['en', 'fr']
  }
];
